"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomElement = (name) => target => {
    if (!customElements.get(name)) {
        customElements.define(name, target);
    }
};
//# sourceMappingURL=custom-element-decorators.js.map